function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M26.9999 1.27075C12.7904 1.27075 1.27075 12.7904 1.27075 26.9999C1.27075 41.2095 12.7904 52.7291 26.9999 52.7291C41.2095 52.7291 52.7291 41.2095 52.7291 26.9999C52.7291 12.7904 41.2095 1.27075 26.9999 1.27075ZM43.9511 13.0739C47.0667 16.8619 48.9374 21.7125 48.9374 26.9999C48.9374 39.1154 39.1154 48.9374 26.9999 48.9374C21.5479 48.9374 16.5603 46.9484 12.7232 43.6564C13.2233 43.2163 13.6681 42.7197 13.9999 42.1666C15.2999 39.9999 16.1666 36.7499 13.9999 33.4999C13.5252 32.8217 12.923 32.1223 12.3198 31.4215L12.3198 31.4215C10.9958 29.8836 9.66659 28.3395 9.66659 26.9999C9.66659 25.5708 11.6303 24.6 13.7588 23.5476C15.5029 22.6854 17.3575 21.7684 18.3333 20.4999C20.2833 17.8999 18.1166 13.3499 17.2499 11.8333C16.5437 10.562 15.7454 9.56708 14.855 8.72829C17.7664 6.78924 21.1675 5.52747 24.8333 5.16807C24.8333 5.22226 24.8333 5.27731 24.8333 5.33325C24.8333 6.17359 25.1112 7.26366 25.9191 7.99258C26.3624 8.39254 26.9577 8.71827 27.5513 9.04302C28.3862 9.49983 29.2176 9.95468 29.6172 10.6114C29.9323 11.1293 29.9896 11.8245 30.0494 12.5498C30.1036 13.2073 30.1598 13.8895 30.4119 14.4871C30.9508 15.7643 32.3735 16.1666 33.4999 16.1666C34.4553 16.1666 39.623 14.9871 43.9511 13.0739Z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M42.1665 28.95C42.1665 35.6666 33.4998 43.9 29.1665 42.1666C25.2665 40.65 28.0832 37.6166 26.9998 28.95C26.5665 25.4833 30.4665 22.45 34.5832 22.45C38.6998 22.45 42.1665 25.2666 42.1665 28.95Z",
  clipRule: "evenodd",
  opacity: 0.6
});

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.5687f515.svg";
export { ForwardRef as ReactComponent };